// extracted by mini-css-extract-plugin
export var menuIcon = "_pn-0";
export var menuIconInline = "_pn-1";